var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390.67 390.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.9,0H34.77C15.65,0,0,15.65,0,34.77V355.9c0,19.12,15.65,34.77,34.77,34.77H355.9c19.12,0,34.77-15.65,34.77-34.77V34.77c0-19.12-15.65-34.77-34.77-34.77ZM125.22,320.89h-60.4V139.15h60.4v181.74Zm-30.2-206.55h-.39c-20.27,0-33.38-13.96-33.38-31.41s13.51-31.4,34.17-31.4,33.38,13.57,33.78,31.4c0,17.44-13.11,31.41-34.17,31.41Zm248.02,206.55h-60.4v-97.22c0-24.43-8.74-41.1-30.6-41.1-16.68,0-26.63,11.24-30.99,22.1-1.6,3.87-1.99,9.31-1.99,14.74v101.49h-60.41s.79-164.69,0-181.74h60.41v25.75c8.02-12.38,22.37-30.01,54.44-30.01,39.75,0,69.55,25.98,69.55,81.79v104.21Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.db0d5568d41aa133194efe4a8e630c05.svg";
export { ForwardRef as ReactComponent };